import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-f6f832c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "table w-100" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "text-center mt-5" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit scoring configuration",
          text: "Edit scoring configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Display Label",
                text: "Display Label"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Min Value",
                text: "Min Value"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Max Value",
                text: "Max Value"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Color",
                text: "Color"
              })
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localPointsConfig.totalPointsAndValues, (pointConfig, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.localPointsConfig.totalPointsAndValues[index].resultValue) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, _ctx.localPointsConfig.totalPointsAndValues[index].resultValue]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.localPointsConfig.totalPointsAndValues[index].minValue) = $event)
                }, null, 8, _hoisted_10), [
                  [_vModelText, _ctx.localPointsConfig.totalPointsAndValues[index].minValue]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.localPointsConfig.totalPointsAndValues[index].maxValue) = $event)
                }, null, 8, _hoisted_11), [
                  [_vModelText, _ctx.localPointsConfig.totalPointsAndValues[index].maxValue]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "color",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.localPointsConfig.totalPointsAndValues[index].color) = $event)
                }, null, 8, _hoisted_12), [
                  [_vModelText, _ctx.localPointsConfig.totalPointsAndValues[index].color]
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "btn btn-primary w-100 justify-content-center",
                  onClick: ($event: any) => (_ctx.removePointConfig(index))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Remove",
                    text: "Remove"
                  })
                ], 8, _hoisted_13)
              ])
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPointConfig.resultValue) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPointConfig.resultValue]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPointConfig.minValue) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPointConfig.minValue]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPointConfig.maxValue) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPointConfig.maxValue]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "color",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newPointConfig.color) = $event))
              }, null, 512), [
                [_vModelText, _ctx.newPointConfig.color]
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-tertiary w-100 justify-content-center",
                disabled: !_ctx.newPointConfig.resultValue || !_ctx.newPointConfig.minValue || !_ctx.newPointConfig.color,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addPointConfig()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Add",
                  text: "Add"
                })
              ], 8, _hoisted_14)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.localPointsConfig.totalPointsAndValues.length == 0,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveConfig()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Save",
            text: "Save"
          })
        ], 8, _hoisted_16)
      ])
    ])
  ]))
}